import React from "react";
import InnerBanner from "../../Components/InnerBanner";
import BreadCrumb from "../../Components/BreadCrumb";
import Spinner from "../../Components/Spinner";
import { useGetMinisterQuery } from "../../../../redux/services/internal/apiHome";

const MinisterDetailPage = ({ benchId }) => {
  const {
    data: ministerData,
    isLoading,
    isError,
  } = useGetMinisterQuery(benchId);

  if (isLoading) {
    return <Spinner />;
  }

  if (isError) {
    return <div>Error fetching gallery data!</div>;
  }
  return (
    <>
      {/* <InnerBanner title="Minister Detail Page" /> */}
      <div class="col-12 col-sm-12 col-md-9 col-lg-9">
        <BreadCrumb title="Chairman Detail Page" />

        <div className="about-bg inner-page-section my-4">
          <div className="container">
            <div className="row">
              <div className=" col-12 col-md-3">
                <div className="profile-img">
                  <img
                    src={
                      ministerData?.data?.minister_image ||
                      "images/no-image.gif"
                    }
                    alt="minister"
                  />
                  <div className="chairmen-name-designation">
                    <h3>
                      {ministerData?.data?.minister_name || "Hon'ble Chairman"}
                    </h3>
                    <h4>{ministerData?.data?.minister_title || "Chairman"}</h4>
                  </div>
                </div>
              </div>
              <div className=" col-12 col-md-9">
                <div className="pfr-text">
                  <div className="title-sec">
                    {" "}
                    <h4 className="httxt ">
                      {ministerData?.data?.minister_name ||
                        "Hon'ble Justice K.S.AHLUWALIA"}
                    </h4>
                  </div>

                  <h5>{ministerData?.data?.minister_title || "Chairman"}</h5>
                  {/* <p > {ministerData?.data?.minister_description} </p>  */}
                  <p
                    dangerouslySetInnerHTML={{
                      __html: ministerData?.data?.minister_description,
                    }}
                  ></p>
                </div>
                {/* chairmen message */}
                <div className="chairmen-msg">
                  <div className="titlesec">
                    <h4 className="httxt">A MESSAGE FROM THE CHAIRMAN</h4>
                  </div>
                  <p>
                    The e-Court Project in the Benches of the Railway Claims
                    Tribunal, spread across the country, aims to leverage
                    Information and Communication Technology to modernize and
                    enhance the justice delivery system. It is basically
                    grounded in the "National Policy and Action Plan for
                    Implementation of Information and Communication Technology
                    (ICT) in the Indian Judiciary - 2005," with a focus on
                    aligning with the vision and practices of the Supreme Court
                    of India. The predominant goal is to transform the judicial
                    system into one that is efficient, transparent, and
                    accessible.
                  </p>
                  <div className="key-object">
                    <h5>The key objectives of the e-Court Project include:</h5>

                    <ul>
                      <li>
                        <span>
                          Efficient and Time-bound Citizen-Centric Services
                          Delivery:
                        </span>
                        The initiative seeks to streamline and expedite the
                        services provided to litigants, ensuring that the
                        judicial process is paperless, faster and more
                        responsive to the needs of the public.
                      </li>
                      <li>
                        <span>Decision Support Systems:</span>The project
                        includes the development, installation, and
                        implementation of advanced decision support systems in
                        courts. These systems will assist judges and legal
                        professionals in making more informed and effective
                        decisions.
                      </li>
                      <li>
                        <span>Automation for Transparency:</span>A critical
                        aspect of the project is the automation of court
                        processes. This will make information more accessible,
                        transparent, and easier for stakeholders to access,
                        thereby enhancing trust and reducing administrative
                        delays.
                      </li>
                      <li>
                        <span>Enhancing Judicial Productivity:</span>4.The
                        project aims to improve both the quality and quantity of
                        judicial output. By incorporating technology, the system
                        will become more affordable, predictable, and efficient.
                        This will contribute to a more reliable and
                        cost-effective justice delivery system, which ultimately
                        benefits all stakeholders.
                      </li>
                    </ul>
                    <p>
                      By focusing on these goals, the e-Court Project is
                      designed to create a more modern, efficient, and
                      accessible judiciary, ultimately enhancing the delivery of
                      justice across the nation.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MinisterDetailPage;
